export default function Footer() {
  const handleNav = (href: string) => {
    const target = document.querySelector(href);
    if (target) target.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-teal-800 text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img
                src="https://storage.readdy-site.link/project_files/c860f638-6881-464b-a007-254e237632a2/01ecbd60-a775-43b2-95ff-ed82a8bcfa34_logo-insercom.ps.png?v=560c1c7d20a19292910cedef55066a8d"
                alt="INSERCOM Logo"
                className="h-20 w-auto object-contain"
                style={{ filter: "brightness(0) invert(1)" }}
              />
            </div>
            <p className="text-teal-200 text-sm leading-relaxed">
              Empresa líder en diseño, construcción y mantenimiento de piscinas e hidromasajes en República Dominicana.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { icon: "ri-instagram-fill", label: "Instagram" },
                { icon: "ri-whatsapp-fill", label: "WhatsApp" },
                { icon: "ri-facebook-fill", label: "Facebook" },
              ].map((s) => (
                <a
                  key={s.label}
                  href="#"
                  rel="nofollow"
                  className="w-9 h-9 bg-teal-700 hover:bg-teal-500 rounded-full flex items-center justify-center transition-colors cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-black text-sm uppercase tracking-widest mb-5 text-teal-300">
              <a href="#inicio">Navegación</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: "Inicio", href: "#inicio" },
                { label: "Sobre Nosotros", href: "#nosotros" },
                { label: "Servicios", href: "#servicios" },
                { label: "Galería", href: "#galeria" },
                { label: "Contacto", href: "#contacto" },
              ].map((item) => (
                <li key={item.href}>
                  <button
                    onClick={() => handleNav(item.href)}
                    className="text-teal-200 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-black text-sm uppercase tracking-widest mb-5 text-teal-300">
              <a href="#contacto">Contacto</a>
            </h4>
            <ul className="space-y-3 text-sm text-teal-200">
              <li className="flex gap-2 items-start">
                <i className="ri-map-pin-fill text-teal-400 mt-0.5" />
                <span>Av. Tiradentes, Plaza Alva, Santo Domingo, R.D.</span>
              </li>
              <li className="flex gap-2 items-center">
                <i className="ri-phone-fill text-teal-400" />
                <span>+1 809-973-2576</span>
              </li>
              <li className="flex gap-2 items-center">
                <i className="ri-mail-fill text-teal-400" />
                <span>info@insercom.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-teal-700 py-5">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-3 text-teal-300 text-xs">
          <p>© {new Date().getFullYear()} INSERCOM. Todos los derechos reservados.</p>
          <p>Diseño, construcción y mantenimiento de piscinas en República Dominicana</p>
        </div>
      </div>
    </footer>
  );
}
